interface DropzoneErrorAlertProps {
  message: string;
  className?: string;
}

export const DropzoneErrorAlert = ({
  message,
  className = '',
}: DropzoneErrorAlertProps) => {
  return (
    <div
      className={`rounded-md border border-red-300 dark:border-red-700 bg-red-50 dark:bg-red-900/20 px-3 py-2 ${className}`}
      role='alert'
    >
      <span className='text-sm text-red-700 dark:text-red-300'>{message}</span>
    </div>
  );
};
